import { FC, PropsWithChildren } from 'react';
import { noop } from 'lodash';

import { IonToggle } from '@ionic/react';
import classNames from 'classnames';

import styles from './Toggle.module.scss';

export type ToggleProps = PropsWithChildren<{
  value?: boolean;
  className?: string;
  onChange?: (v: boolean) => void;
}>;

export const Toggle: FC<ToggleProps> = ({
  children,
  className,
  value = false,
  onChange = noop,
}) => {
  return (
    <IonToggle
      checked={value}
      alignment="center"
      labelPlacement="start"
      className={classNames(styles.root, className)}
      onIonChange={({ detail: { checked } }) => onChange(checked)}
    >
      {children}
    </IonToggle>
  );
};
